// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"9356dfea","528":"23c93e7c","532":"f9eb013c","592":"00057c1d"}[chunkId] + ".chunk.js";
};